import { render, staticRenderFns } from "./Bimini_twoColumnSection.vue?vue&type=template&id=22b39f38&scoped=true"
import script from "./Bimini_twoColumnSection.vue?vue&type=script&lang=ts"
export * from "./Bimini_twoColumnSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b39f38",
  null
  
)

export default component.exports